import ButtonPrimary from "@/components/ButtonPrimary";
import useAddressConvert from "@/hooks/useAddressConvert";
import useUpdateEffect from "@/hooks/useUpdateEffect";
import useGetReferrerState from "@/web3Hook/useGetReferrerState";
import useHasReferrer from "@/web3Hook/useHasReferrer";
import useRegister from "@/web3Hook/useRegister";
import { Form, FormProps, Input } from "antd"
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

type FieldType = {
    address: string;
};
const Invitation = () => {
    const { t, i18n: { language } } = useTranslation()
    const [searchParams] = useSearchParams();
    const invite_code = (searchParams.get('invite_code') || '');
    const [form] = Form.useForm();
    const { getHasReferrer, hasReferrerLod } = useHasReferrer()
    const { getHasReferrerState, getHasReferrerStateLod } = useGetReferrerState()
    // 注册
    const { register, registerLod } = useRegister()
    // 检测是不是fb 0x地址的函数
    const { validateAddress, transition0x, validateAddress0x } = useAddressConvert()
    // 表单提交处理
    const onFinish: FormProps<FieldType>['onFinish'] = (values) => {
        const { address } = values;
        // 调用注册方法
        const address0x = validateAddress0x(address) ? address : transition0x(address)
        // 这一步代表着地址正确
        register(address0x,
            {
                success: t('register.registerSuccess'),
                error: t('register.registerFailure')
            },
            () => { getHasReferrer() }
        )
    };
    // 自定义校验规则：校验地址格式
    const validatorPledgedPower = () => ({
        async validator(_: any, value: string) {
            // 调用注册方法
            if (!value) {
                return Promise.resolve();
            }
            if (!validateAddress(value)) {
                return Promise.reject(new Error(t('register.invalidInviteAddress')));
            }
            const address0x = validateAddress0x(value) ? value : transition0x(value)
            // 检查地址是否已注册推荐人
            const res = await getHasReferrerState(address0x);
            // 如果邀请人地址未注册，则抛出“未注册”错误，阻止继续注册
            if (!res) {
                return Promise.reject(new Error(t('register.alreadyRegistered')));
            }
            return Promise.resolve();
        },
    });
    useEffect(() => {
        invite_code &&
            form.setFieldsValue({
                address: invite_code,
            });
    }, [form, invite_code]);
    useUpdateEffect(() => {
        form.submit()
    }, [language])
    return (
        <div className="box-border  bg-3e w-[90%] px-6 py-7.5  rounded-2xl absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 md:w-96  ">
            <Form
                form={form}
                name="basic"
                initialValues={{ remember: true }}
                onFinish={onFinish}
                autoComplete="off"
            >
                {/* 邀请者地址输入框 */}
                <p className="text-base pb-7.5 font-semibold text-white">
                    {t('register.inviteAddress')}
                </p>
                <Form.Item<FieldType>
                    name="address"
                    rules={[
                        {
                            required: true,
                            message: t('register.enterInviteAddress')
                        },
                        validatorPledgedPower,
                    ]}
                >
                    <Input
                        className="h-11 box-border"
                        placeholder={t('register.enterInviteAddress')}
                    />
                </Form.Item>

                {/* 提交按钮 */}
                <ButtonPrimary
                    className="h-11.25 mt-2.5"
                    htmlType="submit"
                    text={t('register.confirmButton')}
                    loading={registerLod || getHasReferrerStateLod || hasReferrerLod}
                    block
                />
            </Form>
        </div>
    )
}

export default Invitation